export default "__VITE_ASSET__DU578zsO__"